import { Factory } from 'fishery';

import {
	DeviceCompatibilityLevel,
	DeviceModel,
	DeviceStatus,
	MissingFeatureType
} from '@shure/shared/angular/data-access/system-api/models';

import { PropertyPanelDevice } from '../..';
import { SortedDeviceConditionCollection } from '../sorted-device-condition-collection';

class PropertyPanelDeviceFactory extends Factory<PropertyPanelDevice> {
	/**
	 * Adds a supported (i.e. isMissing = false) feature to the device.
	 * @example ```
	 * const device = propertyPanelDeviceFactory
	 *   .withFeature('audioChannelCount', { count: 1 })
	 *   .build();
	 * ```
	 */
	public withFeature<TKey extends keyof PropertyPanelDevice['features']>(
		featureKey: TKey,
		featureData: Omit<NonNullable<PropertyPanelDevice['features'][TKey]>, keyof MissingFeatureType>
	): this {
		return this.params({
			features: {
				[featureKey]: {
					isMissing: false,
					...featureData
				}
			}
		});
	}
}

export const propertyPanelDeviceFactory = PropertyPanelDeviceFactory.define(({ sequence }) => ({
	id: sequence.toString(),
	hardwareId: `hardware-id-${sequence}`,
	name: `Property-Panel-Device-${sequence}`,
	model: DeviceModel.P300,
	status: DeviceStatus.Online,
	compatibility: DeviceCompatibilityLevel.CompatibleLatest,
	isVirtual: false,
	manufacturer: 'Shure',
	conditions: new SortedDeviceConditionCollection(),
	features: {}
}));
